<template>
  <div class="content-item">
    <h2 class="heading">Service Times</h2>
    <div class="form-group">
      <textarea v-model="service_times" class="form-textarea"></textarea>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Step11',
  props: {
    value: {
      type: Object,
    },
  },
  data() {
    return {
      service_times: '',
    };
  },
  methods: {
    submit() {
      this.$emit('input', {
        ...this.value,
        service_times: this.service_times,
      });
    },
  },
};
</script>
